//import node packages
import React, { useState, useEffect, useRef } from 'react'

//import utility functions
import {addClassToDOM, removeCssClass} from '../../../utilities/function/common'
import {getCycle} from '../../../utilities/function/billingCycle'

//define internal functions
export const onSale = old_price => parseFloat(old_price) > 0
export const renderOnSalePrice = priceItem => {
  const {name,old_price,price} = priceItem
  return (
      <div className={'of-domain-prices-wrapper of-domain-prices-wrapper--sales'}>
        <div className={'of-domain-prices-wrapper__new-price'}>
          <div className={'cycle text-font-3-100'}>{name} -</div>
          <div className={'price status-font-3-100'}>
            ${price}<span className={'short-name'}>{getCycle(name)}</span>
          </div>
        </div>
        <div className={'of-domain-prices-wrapper__old-price'}>
          <div className={'price text-font-4-100'}>
            ${old_price}<span className={'short-name'}>{getCycle(name)}</span>
          </div>
        </div>
      </div>
  )
}
export const renderNormalPrice = priceItem => {
  const {name,price,type} = priceItem || {}
  if(parseFloat(price)===0){
    return (
        <div className={'of-domain-prices-wrapper of-domain-prices-wrapper--normal'}>
          <div className={`price status-font-1-100`}>Free to {type}</div>
        </div>
    )
  }
  return (<div className={'of-domain-prices-wrapper of-domain-prices-wrapper--normal'}>
    <div className={'cycle text-font-3-100'}>{name} -</div>
    <div className={'price text-font-1-100'}>${price}<span className={'short-name'}>{getCycle(name)}</span></div>
  </div>)
}

//main component
let PriceDomain = (props) => {
  //define variables
  const [isOpen, setIsOpen] = useState(false)
  const { value, callback, item, type } = props
  const { price, available } = item
  const priceDomainRef = useRef()

  //define functions
  const getItemIsAvailable = () => {
    return available
  }
  const clickAway = (e) => {
    const currentEl = priceDomainRef.current
    const selectedEl = e.target
    if (selectedEl !== currentEl && !currentEl.contains(selectedEl)) {
      setIsOpen(false)
    }
  }
  const onClickListItem = (e,priceitem) => {
      e.preventDefault()
      callback(priceitem)
      setIsOpen(false)
  }

  const onClickSelectedItem = (e) => {
    e.preventDefault()
    if (getFilteredPrice().length > 1) {
      setIsOpen(!isOpen)
    }
  }

  const getFilteredPrice = () => {
    if (price && price.length > 0 && getItemIsAvailable()) {
      if (type) {
        const filteredPrice = price.filter(item => item.type === type)
        if (filteredPrice && filteredPrice.length > 0 && type === 'transfer') {
          return [filteredPrice[0]]
        }
        return filteredPrice
      }
      return price
    }
    return []
  }

  //define render functions
  const renderPrice = () => {
    if (price && price.length > 0 && getItemIsAvailable()) {

      const renderPriceItem = () => {
        const filteredPrice = getFilteredPrice()
        if (filteredPrice && filteredPrice.length > 0) {
          return filteredPrice.map((priceitem, index) => {
            const { old_price } = priceitem
            const renderContent = () =>{
              if(onSale(old_price)){
                return (
                    renderOnSalePrice(priceitem)
                )
              }
              return(renderNormalPrice(priceitem))
            }
            return (<div key={index} className={'of-domain-prices__item'} onClick={e => {
              onClickListItem(e,priceitem)
            }} onMouseEnter={e=>{
              const el = e.currentTarget
              addClassToDOM(el,'shades-primary-background-1-100')
            }} onMouseLeave={e=>{
              const el = e.currentTarget
              removeCssClass(el,'shades-primary-background-1-100')
            }}>
              {renderContent()}
            </div>)
          })
        }
        return (<></>)
      }
      const renderSelectedPrice = () => {
        if (value) {
          const { price,old_price } = value
          const renderText = () => {
            if (price === '0.00') {
              return (
                  <div className={'of-domain-prices-wrapper of-domain-prices-wrapper--normal'}>
                    <div className={`price status-font-1-100`}>Free to {type}</div>
                  </div>
              )
            }
            if (type === 'transfer') {
              return (
                  <div className={'of-domain-prices-wrapper of-domain-prices-wrapper--normal'}>
                    <div className={'price text-font-1-100'}>${price}</div>
                  </div>
              )
            }
            if(onSale(old_price)){
              return (renderOnSalePrice(value))
            }
            return (renderNormalPrice(value)
            )
          }
          return (<div className={'of-domain-prices__item of-domain-prices__item--selected'} onClick={onClickSelectedItem}>
            {renderText()}
            {getFilteredPrice().length > 1 ? <div className={'arrow text-font-3-100'}><i className={'icon icon-of-arrow'}/>
            </div> : <></>}
          </div>)
        }
      }
      return (
          <div ref={priceDomainRef} className={`of-domain-prices${isOpen ? ' of-domain-prices--open' : ''}${getFilteredPrice().length > 1 ? ' of-domain-prices--list' : ''}`}>
            <div className={'of-domain-prices__top'}>
              {renderSelectedPrice()}
            </div>
            <div className={'of-domain-prices__bottom'}>
              {renderPriceItem()}
            </div>
          </div>
      )
    }
    return (<></>)
  }

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('click', clickAway)
      document.addEventListener('touchstart', clickAway)
    } else {
      document.removeEventListener('click', clickAway)
      document.removeEventListener('touchstart', clickAway)
    }

    return () => {
      document.removeEventListener('click', clickAway)
      document.removeEventListener('touchstart', clickAway)
    }
  }, [isOpen])

  return (renderPrice())
}

export default PriceDomain